import { SET_MY_RECORDS_USAGE } from '../actions/type'

const initialState = {
    package: '',
    usage_in_byte: 0,
    quota_in_byte: 0,
    usage_percent: 0,
    is_unlimit: false,
}

const myRecordsUsage = (state = initialState, action) => {
    switch (action.type) {
        case SET_MY_RECORDS_USAGE: {
            const payload = action.payload;
            return { ...state, ...payload };
        }
        default:
            return state
    }
}

export default myRecordsUsage